module.exports = __webpack_public_path__ + "static/008.thumb-eab067b6a1ca3368b7f9fd0978ec00fd.jpg";